// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"a43d1bee","480":"302c5ec8","838":"cd08ac7b"}[chunkId] + ".js";
};